export var OPEN_MODAL = 'OPEN_MODAL';
export var CLOSE_MODAL = 'CLOSE_MODAL';
export var RESET_MODAL = 'RESET_MODAL';
export var ADD_MODAL_ITEM = 'ADD_MODAL_ITEM';
export var ADD_MODAL_EXTRA = 'ADD_MODAL_EXTRA';
export var ADD_MODAL_WARRANTY = 'ADD_MODAL_WARRANTY';
export var ADD_MODAL_CATEGORY = 'ADD_MODAL_CATEGORY';
export var REMOVE_MODAL_WARRANTY = 'REMOVE_MODAL_WARRANTY';
export var UPDATE_TROLLEY_META_EXTRAS = 'UPDATE_TROLLEY_META_EXTRAS';
export var UPDATE_TROLLEY_META_CATEGORIES = 'UPDATE_TROLLEY_META_CATEGORIES';
export var UPDATE_TROLLEY_SUCCEEDED = 'UPDATE_TROLLEY_SUCCEEDED';
export var UPDATE_GO_TO_TROLLEY_ENABLED = 'UPDATE_GO_TO_TROLLEY_ENABLED';
/**
 * Open the trolley view
 * @method openModal
 * @return {Action}  Action of OPEN_MODAL type
 */

export var openModal = function openModal() {
  return {
    type: OPEN_MODAL
  };
};
/**
 * Close the trolley view
 * @method closeModal
 * @return {Action}  Action of CLOSE_MODAL type
 */

export var closeModal = function closeModal() {
  return {
    type: CLOSE_MODAL
  };
};
/**
 * Clear the current modal
 * @method resetModal
 * @return {Action}  Action of RESET_MODAL
 */

export var resetModal = function resetModal() {
  return {
    type: RESET_MODAL
  };
};
/**
 * Update the meta of a trolley items list
 * @method updateTrolleyMeta
 * @param  {ActionType}  type  The action type to dispatch
 * @return {Action}            Action of @type
 */

export var updateTrolleyMeta = function updateTrolleyMeta(type) {
  return function (meta) {
    return {
      type: type,
      meta: meta
    };
  };
};
export var updateTrolleySucceeded = function updateTrolleySucceeded(partNumber) {
  return {
    type: UPDATE_TROLLEY_SUCCEEDED,
    partNumber: partNumber
  };
};
/**
 * Add main item to the trolley view
 * @method addModalItem
 * @param  {String}  partNumber  The part number to use
 * @param  {String}  quantity    The quantity added
 * @return {Action}              Action of ADD_MODAL_ITEM type
 */

export var addModalItem = function addModalItem(partNumber, quantity) {
  return {
    type: ADD_MODAL_ITEM,
    partNumber: partNumber,
    quantity: quantity
  };
};
/**
 * Add extra item to the trolley view
 * @method addModalExtra
 * @param  {String}  extra  The extra to use
 * @return {Action}         Action of ADD_MODAL_EXTRA type
 */

export var addModalExtra = function addModalExtra(extra) {
  return {
    type: ADD_MODAL_EXTRA,
    extra: extra
  };
};
/**
 * Add warranty item to the trolley view
 * @method addModalWarranty
 * @param  {String}  warranty  The warranty object to use
 * @return {Action}            Action of ADD_MODAL_WARRANTY type
 */

export var addModalWarranty = function addModalWarranty(warranty) {
  return {
    type: ADD_MODAL_WARRANTY,
    warranty: warranty
  };
};
/**
 * Remove warranty item from the trolley view
 * @method removeModalWarranty
 * @param  {String}  warranty  The warranty object to use
 * @return {Action}            Action of REMOVE_MODAL_WARRANTY type
 */

export var removeModalWarranty = function removeModalWarranty(warranty) {
  return {
    type: REMOVE_MODAL_WARRANTY,
    warranty: warranty
  };
};
/**
 * Add category item to the trolley view
 * @method addModalCategory
 * @param  {String}  category  The category to add
 * @return {Action}
 */

export var addModalCategory = function addModalCategory(category) {
  return {
    type: ADD_MODAL_CATEGORY,
    category: category
  };
};
export var updateTrolleyMetaExtras = updateTrolleyMeta(UPDATE_TROLLEY_META_EXTRAS);
export var updateTrolleyMetaCategories = updateTrolleyMeta(UPDATE_TROLLEY_META_CATEGORIES);
export var updateGoToTrolleyEnabled = function updateGoToTrolleyEnabled(payload) {
  return {
    type: UPDATE_GO_TO_TROLLEY_ENABLED,
    payload: payload
  };
};
/**
 * Update the trolley view with extracted fields
 * @method updateModal
 * @param  {Object}       payload  The API response data object
 * @return {ThunkAction}           Dispatcher of ADD_MODAL_ITEM
 */

export var updateModal = function updateModal(partNumber, payload) {
  return function (dispatch) {
    // Get all trolley products
    if (Array.isArray(partNumber)) {
      partNumber.forEach(function (item) {
        dispatch(addModalItem(item, payload.quantity));
      });
    } else {
      dispatch(addModalItem(partNumber, payload.quantity));
    }

    dispatch(updateTrolleySucceeded(partNumber));
  };
};